import React, { useEffect, useState } from 'react';

import {
  PRIVACY_CHOICE_EVENT,
  PRIVACY_POLICY_URL,
  loadSalesIQ,
  readPrivacyChoice,
  setPrivacyChoice,
} from '../Util/PrivacyConsent';

const bar = {
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 2147483000,
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 12,
  padding: '8px 16px',
  background: '#1f1f1f',
  color: '#ffffff',
  font: '14px Roboto, Arial, sans-serif',
  boxShadow: '0 -1px 4px rgba(0,0,0,0.4)',
};

const choiceButton = {
  minWidth: 84,
  padding: '4px 12px',
  border: '1px solid #ffffff',
  borderRadius: 4,
  background: 'transparent',
  color: '#ffffff',
  font: 'inherit',
  cursor: 'pointer',
};

const startChatButton = {
  ...choiceButton,
  background: '#1976d2',
  borderColor: '#1976d2',
};

const link = { color: '#ffffff', textDecoration: 'underline' };

const chatButton = {
  position: 'fixed',
  right: 16,
  zIndex: 2147482000,
  width: 48,
  height: 48,
  borderRadius: '50%',
  border: 'none',
  background: '#1976d2',
  color: '#ffffff',
  cursor: 'pointer',
  boxShadow: '0 2px 6px rgba(0,0,0,0.4)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const chatPanel = {
  position: 'fixed',
  right: 16,
  zIndex: 2147482000,
  width: 260,
  maxWidth: 'calc(100vw - 32px)',
  padding: 12,
  borderRadius: 6,
  background: '#ffffff',
  color: '#1f1f1f',
  font: '14px Roboto, Arial, sans-serif',
  boxShadow: '0 2px 10px rgba(0,0,0,0.4)',
};

// Cookie banner plus our own chat button; neither loads anything third-party until the visitor chooses.
const PrivacyChoices = () => {
  const [choice, setChoice] = useState(() => readPrivacyChoice());
  const [chatPromptOpen, setChatPromptOpen] = useState(false);

  useEffect(() => {
    const handleChoice = event => setChoice(event.detail ? event.detail.choice : readPrivacyChoice());
    window.addEventListener(PRIVACY_CHOICE_EVENT, handleChoice);
    return () => window.removeEventListener(PRIVACY_CHOICE_EVENT, handleChoice);
  }, []);

  const handleChatClick = () => {
    if (choice === 'granted') {
      loadSalesIQ({ open: true });
    } else {
      setChatPromptOpen(open => !open);
    }
  };

  const handleStartChat = () => {
    setChatPromptOpen(false);
    loadSalesIQ({ open: true });
  };

  const chatBottom = choice ? 16 : 64;

  return (
    <>
      {chatPromptOpen && (
        <div style={{ ...chatPanel, bottom: chatBottom + 56 }} role="dialog" aria-label="Chat">
          <div style={{ marginBottom: 10 }}>
            Chats are recorded and kept by Ademero and our chat provider, Zoho.
          </div>
          <button type="button" style={startChatButton} onClick={handleStartChat}>
            Start chat
          </button>
        </div>
      )}
      <button
        type="button"
        aria-label="Chat with us"
        title="Chat with us"
        style={{ ...chatButton, bottom: chatBottom }}
        onClick={handleChatClick}
      >
        <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z" />
        </svg>
      </button>
      {!choice && (
        <div style={bar} role="region" aria-label="Cookie choices">
          <span>We use cookies for analytics and ads, and chats are recorded.</span>
          <button type="button" style={choiceButton} onClick={() => setPrivacyChoice('granted')}>Accept</button>
          <button type="button" style={choiceButton} onClick={() => setPrivacyChoice('denied')}>Decline</button>
          <a href={PRIVACY_POLICY_URL} target="_blank" rel="noopener noreferrer" style={link}>Privacy</a>
        </div>
      )}
    </>
  );
};

export default PrivacyChoices;
